module.exports = __webpack_public_path__ + "img/congratulation.81548ccd.png";